import LSClassFromSchemeConfigure from './LSClassFromSchemeConfigure'

export default LSClassFromSchemeConfigure
